import { Module, Mutation } from 'vuex-module-decorators'
import { SystemCode } from '@/api'
import BaseStore from '@/store/BaseStore'

export interface modalCodeParameterInterface {
  codeKey: string
  title: string
  defaultCode: string
  systemCodes?: SystemCode[]
  multiple?: boolean
  exclusionCodes?: string[]
  disabledCodes?: string[]
  codeLength?: number
  onOkClick?: any
  onCancelClick?: any
}

@Module({
  name: 'ModalCodeStore',
  namespaced: true,
  stateFactory: true
})
export default class ModalCodeStore extends BaseStore {
  _isOpen = false

  _codeKey = ''

  _title = ''

  _defaultCode = ''

  _multiple = false

  _exclusionCodes: string[] = []

  _disabledCodes: string[] = []

  _codeLength: number = 0

  _okCallback: any

  _cancelCallback: any

  _systemCodes: SystemCode[] = []

  _selectedItems: SystemCode | SystemCode[] | null = null

  get isOpen(): boolean {
    return this._isOpen
  }

  get codeKey(): string {
    return this._codeKey
  }

  get title(): string {
    return this._title
  }

  get defaultCode(): string {
    return this._defaultCode
  }

  get multiple(): boolean {
    return this._multiple
  }

  get exclusionCodes(): string[] {
    return this._exclusionCodes
  }

  get disabledCodes(): string[] {
    return this._disabledCodes
  }

  get codeLength(): number {
    return this._codeLength
  }

  get parameter(): modalCodeParameterInterface {
    return {
      codeKey: this._codeKey,
      title: this._title,
      defaultCode: this._defaultCode,
      systemCodes: this._systemCodes,
      multiple: this._multiple,
      exclusionCodes: this._exclusionCodes,
      codeLength: this._codeLength
    }
  }

  get systemCodes(): SystemCode[] {
    return this._systemCodes
  }

  @Mutation
  public open(params: modalCodeParameterInterface) {
    this._isOpen = true
    this._codeKey = params.codeKey
    this._title = params.title
    this._systemCodes = params.systemCodes || []
    this._defaultCode = params.defaultCode
    this._multiple = params.multiple ? params.multiple : false
    this._exclusionCodes = params.exclusionCodes ? params.exclusionCodes : []
    this._disabledCodes = params.disabledCodes ? params.disabledCodes : []
    this._codeLength = params.codeLength ?? 0
    this._okCallback = params.onOkClick
    this._cancelCallback = params.onCancelClick
  }

  @Mutation
  public close() {
    this._isOpen = false
  }

  @Mutation
  public ok(selectedItems: SystemCode | SystemCode[] | null) {
    this._selectedItems = selectedItems

    const result = this._okCallback ? this._okCallback(selectedItems) : true
    if (result === false) {
      return
    }

    this._isOpen = false
  }

  @Mutation
  public cancel() {
    const result = this._cancelCallback ? this._cancelCallback() : true
    if (result === false) {
      return
    }

    this._isOpen = false
  }
}
